// 認証期間切れ処理 (リダイレクトあり:true なし:false)
import {
  signin_path
} from "./Apollo_links";

export const ApolloExpired = (
    err : any,                // 必須
    msg : string,             // 必須
    data : any,               // メッセージ表示のため必須
    setmsg : any,             // メッセージ表示のため必須
    history : any,            // 再サインイン後のリダイレクトのため必須
    setDrawerState ? : any,   // ドロワーを使用している場合は閉じるため指定する
    drawerState ? : any,      // ドロワーを使用している場合は閉じるため指定する
) => {
  // ドロワーを閉じる
  closeDrawer(setDrawerState, drawerState);
  // エラーメッセージ表示
  displayError(err, msg, data, setmsg);
  // リダイレクト
  var reslut = redirect(err, history);
  // リダイレクト有無返却
  return reslut;
}

// 認証期間切れ指定リダイレクト先遷移処理 (リダイレクトあり:true なし:false)
export const ApolloExpiredSpecify = (
  err : any,                // 必須
  msg : string,             // 必須
  data : any,               // メッセージ表示のため必須
  setmsg : any,             // メッセージ表示のため必須
  history : any,            // 再サインイン後のリダイレクトのため必須
  url : string,             // 再サインイン後のリダイレクトのため必須
  setDrawerState ? : any,   // ドロワーを使用している場合は閉じるため指定する
  drawerState ? : any,      // ドロワーを使用している場合は閉じるため指定する
) => {
  // ドロワーを閉じる
  closeDrawer(setDrawerState, drawerState);
  // エラーメッセージ表示
  displayError(err, msg, data, setmsg);
  // リダイレクト
  var reslut = redirect(err, history, url);
  // リダイレクト有無返却
  return reslut;
}

// ドロワーを閉じる
const closeDrawer = (
  setDrawerState ? : any,   // ドロワーを使用している場合は閉じるため指定する
  drawerState ? : any,      // ドロワーを使用している場合は閉じるため指定する
) => {
  if (setDrawerState && drawerState) {
    // ドロワーを閉じる
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    })
  }
  return;
} 

// エラーメッセージ表示
const displayError = (
  err : any,                // 必須
  msg : string,             // 必須
  data : any,               // メッセージ表示のため必須
  setmsg : any,             // メッセージ表示のため必須
) => {
  const errMsg = err.errmsg ? err.errmsg : msg;
  setmsg({
    type: "setMessage",
    payload: {
      ...data,
      open: true,
      type: "error",
      message: errMsg,
    }
  });
  return;
} 

// リダイレクト
const redirect = (
  err : any,                // 必須
  history : any,            // 再サインイン後のリダイレクトのため必須
  url ? : string,           // 再サインイン後のリダイレクトのため必須
) => {
  // リダイレクト
  if (err.redirecturl) {
    var redirectUrl = "/";
    if (url) {
      redirectUrl += err.redirecturl + url;
    } else if (url == signin_path){
        redirectUrl = "/";
    } else if (history.location.pathname == signin_path){
      return true;
    } else if (history.location.pathname == redirectUrl){
      return true;
    } else {
      //redirectUrl += err.redirecturl + history.location.pathname;
      redirectUrl += err.redirecturl + redirectUrl;
    }
    //alert("リダイレクト : " + redirectUrl);
    history.push(redirectUrl);
    return true;
  }
  return false;
} 
